import httpClient from "./httpClient";

export function stageEntrants(payload) {
  return httpClient.post("/lottery/entrants", payload).then((res) => res.data);
}

export function drawWinners(payload) {
  return httpClient.post("/lottery/draw", payload).then((res) => res.data);
}

export function entrantList(classId) {
  return httpClient.get("/lottery/entrants", { params: { classId } }).then((res) => res.data.data);
}

export function winnerList(classId) {
  return httpClient.get("/lottery/winners", { params: { classId } }).then((res) => res.data.data);
}

export function nonWinnerList(classId) {
  return httpClient.get("/lottery/non-winners", { params: { classId } }).then((res) => res.data.data);
}
